import React, { useEffect, useState } from 'react';
import { Check, Lock, ShieldCheck, Eye, Clock } from 'lucide-react';
export function PricingBundle() {
  const [selectedTier, setSelectedTier] = useState(2);
  const [timeLeft, setTimeLeft] = useState({
    hours: 3,
    minutes: 40,
    seconds: 32
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const handleSelect = (tier: number) => {
    setSelectedTier(tier);
  };
  const getTierName = () => {
    if (selectedTier === 1) return 'ESSENTIAL';
    if (selectedTier === 2) return 'COMPLETE';
    return 'PREMIUM';
  };
  const getTierPrice = () => {
    if (selectedTier === 1) return '17.00';
    if (selectedTier === 2) return '37.00';
    return '57.00';
  };
  const getTierCartUrl = () => {
    if (selectedTier === 1) return 'https://decomagickit.shop/cart/50976790085910:1';
    if (selectedTier === 2) return 'https://decomagickit.shop/cart/51086169145622:1';
    return 'https://decomagickit.shop/cart/51086169866518:1';
  };
  return <section id="pricing" className="py-16 px-4 bg-[#b5e5e0] relative overflow-hidden font-nunito" data-id="element-147">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-148">
        {/* Product Cover Image */}
        <div className="flex justify-center mb-8" data-id="element-149">
          <img src="https://cdn.magicpatterns.com/uploads/ugovqzPAKeSwEUBmRN2t8T/Portada_deco_Ingles.png" alt="Magic Party Kit - Product Cover" className="w-full max-w-sm rounded-3xl shadow-xl border-4 border-white" data-id="element-150" />
        </div>

        <div className="space-y-8 mb-8" data-id="element-151">
          {/* TIER 1 - ESSENTIAL */}
          <div onClick={() => handleSelect(1)} className={`cursor-pointer rounded-3xl transition-all duration-300 bg-white border-4 ${selectedTier === 1 ? 'border-pink-500 shadow-lg scale-[1.02]' : 'border-transparent shadow-md hover:border-pink-200'}`} data-id="element-152">
            <div className="p-6" data-id="element-153">
              <div className="flex justify-between items-start mb-4" data-id="element-154">
                <div data-id="element-155">
                  <h3 className="text-xl font-bold text-gray-900 font-baloo leading-tight flex items-center gap-2" data-id="element-156">
                    <span data-id="element-157">⚡</span> MAGIC PARTY KIT
                    <br data-id="element-158" />
                    ESSENTIAL
                  </h3>
                  <p className="text-gray-500 text-sm mt-1" data-id="element-159">
                    The perfect base for your party
                  </p>
                </div>
                <div className="text-right" data-id="element-160">
                  <div className="text-4xl font-bold text-pink-500 font-baloo" data-id="element-161">
                    €17.00
                  </div>
                </div>
              </div>

              <div className="border-t border-dashed border-pink-200 my-4" data-id="element-162"></div>

              <div data-id="element-163">
                <p className="text-pink-500 font-bold text-sm mb-3 flex items-center gap-2" data-id="element-164">
                  <span data-id="element-165">📦</span> INCLUDES:
                </p>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-166">
                  <li className="flex items-start gap-2" data-id="element-167">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-168" />
                    <span data-id="element-169">+10,000 printable templates ready to use</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-170">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-171" />
                    <span data-id="element-172">10 exclusive bonuses included</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* TIER 2 - COMPLETE (HIGHLIGHTED) */}
          <div onClick={() => handleSelect(2)} className={`cursor-pointer rounded-3xl transition-all duration-300 bg-white border-4 relative ${selectedTier === 2 ? 'border-pink-500 shadow-xl scale-[1.02]' : 'border-pink-300 shadow-md hover:border-pink-400'}`} data-id="element-173">
            {/* Recommended Badge */}
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-pink-400 text-white text-sm font-bold px-6 py-1.5 rounded-full shadow-sm flex items-center gap-2 whitespace-nowrap" data-id="element-174">
              <span data-id="element-175">⭐</span> MOST RECOMMENDED
            </div>

            <div className="p-6 pt-8" data-id="element-176">
              <div className="flex justify-between items-start mb-4" data-id="element-177">
                <div data-id="element-178">
                  <h3 className="text-xl font-bold text-gray-900 font-baloo leading-tight flex items-center gap-2" data-id="element-179">
                    <span data-id="element-180">🏆</span> MAGIC PARTY KIT
                    <br data-id="element-181" />
                    COMPLETE
                  </h3>
                  <p className="text-gray-500 text-sm mt-1" data-id="element-182">
                    Everything in Essential + Video Course
                    <br data-id="element-183" />
                    step by step
                  </p>
                </div>
                <div className="text-right flex flex-col items-end" data-id="element-184">
                  <div className="text-4xl font-bold text-pink-500 font-baloo leading-none mb-1" data-id="element-185">
                    €37.00
                  </div>
                  <div className="text-gray-400 line-through text-sm font-bold mb-1" data-id="element-186">
                    €67.00
                  </div>
                  <div className="bg-pink-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-187">
                    <span data-id="element-188">🔥</span> SAVE 44%
                  </div>
                </div>
              </div>

              <div className="border-t border-dashed border-pink-200 my-4" data-id="element-189"></div>

              <div className="mb-4" data-id="element-190">
                <p className="text-pink-500 font-bold text-sm mb-3 flex items-center gap-2" data-id="element-191">
                  <span data-id="element-192">📦</span> INCLUDES EVERYTHING IN ESSENTIAL, PLUS:
                </p>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-193">
                  <li className="flex items-start gap-2" data-id="element-194">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-195" />
                    <span data-id="element-196">+10,000 printable templates</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-197">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-198" />
                    <span data-id="element-199">10 exclusive bonuses</span>
                  </li>
                </ul>
              </div>

              <div className="border-t border-dashed border-pink-200 my-4" data-id="element-200"></div>

              <div data-id="element-201">
                <p className="text-gray-800 font-bold text-sm mb-3 flex items-center gap-2" data-id="element-202">
                  <span data-id="element-203">🎬</span> Video Course — learn how to make:
                </p>
                <div className="grid grid-cols-2 gap-x-2 gap-y-2 text-xs text-gray-600" data-id="element-204">
                  <div className="flex items-start gap-1.5" data-id="element-205">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-206" />
                    <span data-id="element-207">Invitations in Canva</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-208">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-209" />
                    <span data-id="element-210">Sticker design</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-211">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-212" />
                    <span data-id="element-213">Coloring booklets</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-214">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-215" />
                    <span data-id="element-216">Customize templates</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-217">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-218" />
                    <span data-id="element-219">Work from your phone</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-220">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-221" />
                    <span data-id="element-222">Creative stationery assembly</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-223">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-224" />
                    <span data-id="element-225">Files for Cricut</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-226">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-227" />
                    <span data-id="element-228">Silhouette & plotter</span>
                  </div>
                </div>
              </div>

              {/* Selection Indicator */}
              {selectedTier === 2 && <div className="mt-6 bg-pink-500 text-white text-center py-3 rounded-xl font-bold text-sm flex items-center justify-center gap-2" data-id="element-229">
                  <div className="w-4 h-4 bg-white rounded-sm flex items-center justify-center" data-id="element-230">
                    <Check className="w-3 h-3 text-pink-500" data-id="element-231" />
                  </div>
                  SELECTED — MAGIC PARTY KIT COMPLETE
                </div>}
            </div>
          </div>

          {/* TIER 3 - PREMIUM */}
          <div onClick={() => handleSelect(3)} className={`cursor-pointer rounded-3xl transition-all duration-300 bg-white border-4 ${selectedTier === 3 ? 'border-pink-500 shadow-lg scale-[1.02]' : 'border-transparent shadow-md hover:border-pink-200'}`} data-id="element-232">
            <div className="p-6" data-id="element-233">
              <div className="flex justify-between items-start mb-4" data-id="element-234">
                <div data-id="element-235">
                  <h3 className="text-xl font-bold text-gray-900 font-baloo leading-tight flex items-center gap-2" data-id="element-236">
                    <span data-id="element-237">👑</span> MAGIC PARTY KIT
                    <br data-id="element-238" />
                    PREMIUM
                  </h3>
                  <p className="text-gray-500 text-sm mt-1" data-id="element-239">
                    The most complete package — EVERYTHING
                    <br data-id="element-240" />
                    included
                  </p>
                </div>
                <div className="text-right flex flex-col items-end" data-id="element-241">
                  <div className="text-4xl font-bold text-pink-500 font-baloo leading-none mb-1" data-id="element-242">
                    €57.00
                  </div>
                  <div className="text-gray-400 line-through text-sm font-bold mb-1" data-id="element-243">
                    €76.04
                  </div>
                  <div className="bg-pink-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-244">
                    <span data-id="element-245">🔥</span> SAVE 25%
                  </div>
                </div>
              </div>

              <div className="border-t border-dashed border-pink-200 my-4" data-id="element-246"></div>

              <div className="mb-4" data-id="element-247">
                <p className="text-pink-500 font-bold text-sm mb-3 flex items-center gap-2" data-id="element-248">
                  <span data-id="element-249">👑</span> INCLUDES EVERYTHING IN COMPLETE, PLUS:
                </p>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-250">
                  <li className="flex items-start gap-2" data-id="element-251">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-252" />
                    <span data-id="element-253">+10,000 printable templates</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-254">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-255" />
                    <span data-id="element-256">10 exclusive bonuses</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-257">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-258" />
                    <span data-id="element-259">Complete step-by-step Video Course</span>
                  </li>
                </ul>
              </div>

              <div className="border-t border-dashed border-pink-200 my-4" data-id="element-260"></div>

              <div data-id="element-261">
                <p className="text-gray-800 font-bold text-sm mb-3 flex items-center gap-2" data-id="element-262">
                  <span data-id="element-263">💎</span> Exclusive Premium content:
                </p>
                <div className="grid grid-cols-2 gap-x-2 gap-y-2 text-xs text-gray-600" data-id="element-264">
                  <div className="flex items-start gap-1.5" data-id="element-265">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-266" />
                    <span data-id="element-267">Halloween templates</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-268">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-269" />
                    <span data-id="element-270">Christmas templates</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-271">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-272" />
                    <span data-id="element-273">Sublimation designs</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-274">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-275" />
                    <span data-id="element-276">iPhone designs</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-277">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-278" />
                    <span data-id="element-279">Extra digital invitations</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-280">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-281" />
                    <span data-id="element-282">Entrepreneurship guide</span>
                  </div>
                </div>
              </div>

              {/* Selection Indicator */}
              {selectedTier === 3 && <div className="mt-6 bg-pink-500 text-white text-center py-3 rounded-xl font-bold text-sm flex items-center justify-center gap-2" data-id="element-283">
                  <div className="w-4 h-4 bg-white rounded-sm flex items-center justify-center" data-id="element-284">
                    <Check className="w-3 h-3 text-pink-500" data-id="element-285" />
                  </div>
                  SELECTED — MAGIC PARTY KIT PREMIUM
                </div>}
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="mb-6" data-id="element-286">
          <a href={getTierCartUrl()} target="_blank" rel="noopener noreferrer" className="w-full bg-pink-500 text-white font-baloo font-bold text-xl py-4 px-6 rounded-2xl shadow-[0_6px_0_#D81B60] hover:shadow-[0_3px_0_#D81B60] hover:translate-y-[3px] transition-all duration-200 flex flex-col items-center justify-center gap-1 no-underline" data-id="element-287">
            <span data-id="element-288">🛒 ADD TO CART — MAGIC PARTY KIT {getTierName()}</span>
            <span className="text-xs font-normal flex items-center gap-1 opacity-90" data-id="element-289">
              <span data-id="element-290">⚡</span> Instant access via email after purchase
            </span>
          </a>
        </div>

        {/* Trust Badges */}
        <div className="flex justify-center items-center gap-3 text-xs text-gray-500 font-medium mb-10" data-id="element-291">
          <div className="flex items-center gap-1" data-id="element-292">
            <Lock className="w-3 h-3 text-orange-400" data-id="element-293" /> Secure payment
          </div>
          <span data-id="element-294">·</span>
          <div data-id="element-295">No subscriptions</div>
          <span data-id="element-296">·</span>
          <div data-id="element-297">One-time payment</div>
        </div>

        {/* Urgency & Countdown Section */}
        <div className="space-y-4" data-id="element-298">
          {/* Urgency Indicators */}
          <div className="bg-white rounded-2xl p-4 shadow-sm" data-id="element-299">
            <div className="flex justify-between items-center mb-3" data-id="element-300">
              <div className="flex items-center gap-2 text-sm font-bold text-gray-700" data-id="element-301">
                <span data-id="element-302">🔥</span> Spots available today
              </div>
              <div className="text-pink-500 font-bold text-sm" data-id="element-303">9 remaining</div>
            </div>
            {/* Progress bar */}
            <div className="w-full bg-gray-100 rounded-full h-2 mb-3" data-id="element-304">
              <div className="bg-pink-500 h-2 rounded-full w-[85%]" data-id="element-305"></div>
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-306">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" data-id="element-307"></div>
              11 people are viewing this right now
            </div>
          </div>

          {/* Countdown Timer */}
          <div className="bg-white rounded-3xl p-6 shadow-sm border-2 border-pink-50 text-center" data-id="element-308">
            <div className="flex items-center justify-center gap-2 text-pink-500 font-bold text-sm mb-4" data-id="element-309">
              <span data-id="element-310">⚡</span> SPECIAL OFFER EXPIRES IN
            </div>

            <div className="flex justify-center items-center gap-2 mb-6" data-id="element-311">
              {/* Hours */}
              <div className="flex flex-col items-center" data-id="element-312">
                <div className="bg-pink-500 text-white font-baloo text-4xl font-bold w-16 h-16 rounded-2xl flex items-center justify-center shadow-inner" data-id="element-313">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
                <span className="text-[10px] font-bold text-gray-400 mt-2 tracking-wider" data-id="element-314">
                  HOURS
                </span>
              </div>

              <div className="text-pink-300 text-2xl font-bold pb-6" data-id="element-315">:</div>

              {/* Minutes */}
              <div className="flex flex-col items-center" data-id="element-316">
                <div className="bg-pink-500 text-white font-baloo text-4xl font-bold w-16 h-16 rounded-2xl flex items-center justify-center shadow-inner" data-id="element-317">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </div>
                <span className="text-[10px] font-bold text-gray-400 mt-2 tracking-wider" data-id="element-318">
                  MINUTES
                </span>
              </div>

              <div className="text-pink-300 text-2xl font-bold pb-6" data-id="element-319">:</div>

              {/* Seconds */}
              <div className="flex flex-col items-center" data-id="element-320">
                <div className="bg-pink-500 text-white font-baloo text-4xl font-bold w-16 h-16 rounded-2xl flex items-center justify-center shadow-inner" data-id="element-321">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </div>
                <span className="text-[10px] font-bold text-gray-400 mt-2 tracking-wider" data-id="element-322">
                  SECONDS
                </span>
              </div>
            </div>

            <div className="flex items-center justify-center gap-1.5 text-sm text-gray-600 mb-4" data-id="element-323">
              <Lock className="w-3.5 h-3.5 text-orange-400" data-id="element-324" />
              Price locked at{' '}
              <span className="font-bold text-pink-500" data-id="element-325">
                €{getTierPrice()}
              </span>{' '}
              today only
            </div>

            <div className="bg-pink-400 text-white font-bold py-3 px-4 rounded-xl text-sm shadow-sm flex items-center justify-center gap-2" data-id="element-326">
              <span data-id="element-327">🎉</span> Save up to 60% — Offer valid today!
            </div>
          </div>
        </div>
      </div>
    </section>;
}